import { AxiosResponse } from "axios";
import { apiClient } from "../base-client";
import { createServerApiClient } from "../server-base-client";

export async function getUnreadMessagesCount(
  accountId: string,
): Promise<number> {
  if (!accountId) {
    return 0;
  }
  const response = await apiClient.get<number>(
    `/accounts/${accountId}/conversations/unread-messages-count`,
  );
  return response.data;
}

export interface EnsureAccountSetupInput {
  userId: string;
  accountId?: string;
  createUserProfileInput?: {
    userId: string;
    email?: string;
    firstName?: string;
    lastName?: string;
    phone?: string;
    leadZipcode?: string;
    optIn?: boolean;
    yzAnonymousId?: string;
  };
}

export interface EnsureAccountSetupResponse {
  userId: string;
  accountId: string;
}

export async function ensureAccountSetup(
  input: EnsureAccountSetupInput,
  authToken?: string,
): Promise<EnsureAccountSetupResponse> {
  const client = await createServerApiClient(authToken);

  const response: AxiosResponse<EnsureAccountSetupResponse> = await client.post(
    "/users/ensure-account-setup",
    input,
  );

  return response.data;
}
